import styled from "styled-components";

export const EditTournamentReservationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const EditTournamentReservationTop = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    width: 169px;
    color: #121212;
  }
`;

export const EditTournamentReservationInputBox = styled.div`
  display: flex;
  gap: 30px;
  position: relative;
  align-items: flex-start;
  width: max-content;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    width: 169px;
    color: #121212;
  }
`;

export const EditTournamentReservationInputContent = styled.div`
  width: 100%;
  height: 421px;
  border-radius: 16px;
  border: 3px dashed #e5e5e5;
  box-sizing: border-box;
  background: #fff;
`;

export const EditTournamentReservationToggle = styled.div<{
  isOn: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 24px;
  border-radius: 15px;
  background: ${(p) => (p.isOn ? "#7F25FB" : "#E5E5E5")};
  position: relative;
  box-sizing: border-box;
`;

export const EditTournamentReservationToggleCircle = styled.div<{
  isOn: boolean;
}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  left: ${(p) => (p.isOn ? "20px" : "2px")};
  transition: left 0.3s ease-in-out;
`;

export const EditTournamentReservationImageDrop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;

  > .icon {
    border-radius: 33554400px;
    background: #f0eaff;
    display: flex;
    width: 64px;
    height: 64px;
    justify-content: center;
    align-items: center;
  }

  > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;

    > .title {
      color: #121212;
      text-align: center;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 19.2px */
    }

    > .description {
      color: #808080;
      text-align: center;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%; /* 16.8px */
    }
  }
`;
